/// <amd-module name="CodeCoverage/CodeCoverageCiTab/Services/CodeCoveragePipelineCiTabService" />
import * as React from "react";

import { ObservableArray } from "VSS/Core/Observable";
import { ITabService } from "VSS/Features/PlatformUI/ContributedTab";
import { IVssPageContext, Services } from "VSS/Platform/Context";
import { IVssContributedTab } from "VSSUI/Tabs.Types";

import { BuildStatus } from "Build/Client/Contracts/Build";
import { IRunViewContributedTabProps } from "Build/Run/RunViewContributedTab";
import { IRepoCodeCoverageProps, RepoCodeCoverage } from "CodeCoverage/CodeCoverageCiTab/Components/RepoCodeCoverage";
import * as Resources from "CodeCoverage/CodeCoverageCiTab/Resources";
import { CoverageTabProviderServiceBase } from "CodeCoverage/CodeCoverageCiTab/Services/CoverageTabProviderServiceBase";
import { TelemetryEvents } from "CodeCoverage/ViewCommon/Constants";
import { publish } from "CodeCoverage/ViewCommon/Helpers";
import { RunViewArtifact } from "CodeCoverage/ViewCommon/RunViewArtifact";

export class CodeCoveragePipelineCiTabService extends CoverageTabProviderServiceBase implements ITabService<IRunViewContributedTabProps> {
    private tabs: ObservableArray<any>;
    private buildContext: IRunViewContributedTabProps;
    private coverageTabEnabled: boolean = false;

    public _serviceStart(pageContext: IVssPageContext): void {
        super._serviceStart(pageContext);
        this.tabs = new ObservableArray<IVssContributedTab>();
    }

    public getTabs(id: string, buildContext?: IRunViewContributedTabProps) {
        if (buildContext) {
            this.buildContext = buildContext;

            if (buildContext.status && buildContext.status.value !== BuildStatus.Completed) {
                buildContext.status.subscribe(this.onBuildStatusChanged);
            } else {
                this.onBuildStatusChanged();
            }
        }

        return this.tabs;
    }

    protected initTab = (getTab: () => React.ComponentElement<IRepoCodeCoverageProps, RepoCodeCoverage>) => {
        this.tabs.push({
            // Keeping this id same as old code coverage tab
            id: "codecoverage-tab",
            render: () => {
                return getTab();
            },
            name: Resources.CodeCoverageTabName,
            onBeforeTabChange: () => {
                publish(this.pageContext, TelemetryEvents.CodeCoverageCiTabClicked);
                return true;
            }
        });
    };

    private onBuildStatusChanged = () => {
        // Only render tab once build is completed
        if (!this.coverageTabEnabled && this.buildContext && this.buildContext.status.value === BuildStatus.Completed) {
            this.coverageTabEnabled = true;

            const runViewArtifact = new RunViewArtifact(
                this.buildContext.runId.value,
                this.buildContext.projectId.value,
                this.buildContext.sourceBranch.value,
                this.buildContext.sourceRepositoryId.value,
                this.buildContext.sourceRepositoryType.value,
                this.buildContext.sourceVersion.value,
                this.buildContext.finishTime.value
            );

            this.startFetchTab(runViewArtifact);
        }
    };
}

export let CodeCoveragePipelineCiTabServiceName = "codecoverage-pipeline-ci-tab-service";
Services.add(CodeCoveragePipelineCiTabServiceName, { serviceFactory: CodeCoveragePipelineCiTabService });
